<template>
  <div class="HealthPolicyNumber">
    <CardInfoComponent
      v-if="message"
      :icon="message.icon"
    >
      {{ message.label }}
    </CardInfoComponent>
    <BaseInput
      :id="id"
      :placeholder="placeholder"
      :label="label"
      v-model="policyNumber"
      :editable="editable"
      :maxlength="MAX_CHARS_POLICY_NUMBER"
      :rules="[validationRules.required, validationRules.format]"
      @keydown="isNumberKey($event)"
    />
    <slot />
    <img
      src="@/assets/img/common/tarjetaSalud.svg"
      width="161"
      height="86"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import { isNumberKey } from '@/utils/input.utils'

import BaseInput from '@/modules/core/components/ui/BaseInput.vue'
import { useRules } from '@/modules/core/composables/useRulesComposable'
import { MAX_CHARS_POLICY_NUMBER } from '@/modules/core/constants/common'
import type { ValidationRuleType } from '@/modules/core/models/types'
import type TagAlertValue from '@/modules/core/models/TagAlertValue'

import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'

const emit = defineEmits(['update:modelValue'])
const { required, validPolicyNumber } = useRules()

interface PropsInterface {
  id: string
  modelValue: string | null
  placeholder?: string
  rules?: ValidationRuleType[]
  label?: string
  icon?: string
  editable?: boolean
  message?: TagAlertValue
}

const props = withDefaults(defineProps<PropsInterface>(), {
  modelValue: '',
  rules: () => [],
  placeholder: '',
  editable: true
})

const validationRules = {
  required,
  format: validPolicyNumber
}

const policyNumber = computed({
  get: () => props.modelValue ?? '',
  set: (value: string) => emit('update:modelValue', value)
})
</script>